import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-institutional-dev-plan',
  templateUrl: './institutional-dev-plan.component.html',
  styleUrls: ['./institutional-dev-plan.component.scss']
})
export class InstitutionalDevPlanComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
